import * as type from './constant';

export const getPresence = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getPresenceSuccess = (payload, month) => ({
  type: type.GET_SUCCESS,
  payload,
  month,
});

export const getPresenceError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addPresence = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addPresenceSuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updatePresence = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updatePresenceSuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deletePresence = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deletePresenceSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationPresenceError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
